'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _search = require('../actions/search');

var Actions = _interopRequireWildcard(_search);

var _searchHelper = require('../../helpers/search-helper');

var searchHelper = _interopRequireWildcard(_searchHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function mergeSearchResults(state, searchResults) {
    var currentSearchResults = Object.assign({}, state.searchResults);
    var searchResultsCopy = Object.assign({}, searchResults);
    var currentResults = currentSearchResults.results;
    if (!currentResults) {
        return searchResultsCopy;
    }
    currentResults = currentResults.concat(searchResultsCopy.results);
    searchResultsCopy.results = currentResults;
    return searchResultsCopy;
}

function mergeChannelInfoToSearchResults(searchResults, channelInfo) {
    searchResults.results.forEach(function (result) {
        if (!result.channelInfo) {
            var matchingChannelInfo = channelInfo.find(function (channel) {
                return result.id === channel.contentKey;
            });
            if (matchingChannelInfo) {
                result.metadata.channelInfo = matchingChannelInfo;
            }
        }
    });
    return searchResults;
}

var initialState = {
    searchQuery: '',
    searchId: '',
    searchResults: {},
    isFetchingSearchResults: false,
    isFetchingChannelInfo: false,
    metadataResolve: false,
    pageNumber: 0,
    scrollPositionY: 0
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case Actions.GET_SEARCH_START:
            {
                return _extends({}, state, {
                    isFetchingSearchResults: true,
                    metadataResolve: false,
                    searchResults: action.clearSearchResults ? {} : state.searchResults,
                    searchId: searchHelper.generateSearchId(state, action.newQuery),
                    error: null
                });
            }
        case Actions.GET_SEARCH_COMPLETE:
            {
                return _extends({}, state, {
                    isFetchingSearchResults: false,
                    searchResults: mergeSearchResults(state, action.searchResults),
                    searchQuery: action.searchQuery,
                    pageNumber: action.searchResults.page
                });
            }
        case Actions.GET_SEARCH_FAILURE:
            {
                return _extends({}, state, {
                    isFetchingSearchResults: false,
                    metadataResolve: true,
                    error: action.error,
                    searchQuery: action.searchQuery
                });
            }
        case Actions.GET_CHANNEL_INFO_START:
            {
                return _extends({}, state, {
                    isFetchingChannelInfo: true,
                    metadataResolve: false
                });
            }
        case Actions.GET_CHANNEL_INFO_END:
            {
                var currentSearchResults = Object.assign({}, state.searchResults);
                return _extends({}, state, {
                    isFetchingChannelInfo: false,
                    metadataResolve: true,
                    searchResults: mergeChannelInfoToSearchResults(currentSearchResults, action.channelInfo)
                });
            }
        case Actions.GET_CHANNEL_INFO_FAILURE:
            {
                return _extends({}, state, {
                    isFetchingChannelInfo: false,
                    metadataResolve: true,
                    channelInfoError: action.channelInfoError
                });
            }
        case Actions.SEARCH_UPDATE_SCROLL_POSITION:
            {
                return _extends({}, state, {
                    scrollPositionY: action.scrollPositionY
                });
            }
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/search.js
// module id = 785
// module chunks = 0